import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=3aa226fe"
import script from "./Confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa226fe')) {
      api.createRecord('3aa226fe', component.options)
    } else {
      api.reload('3aa226fe', component.options)
    }
    module.hot.accept("./Confirmation.vue?vue&type=template&id=3aa226fe", function () {
      api.rerender('3aa226fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/dialogs/Confirmation.vue"
export default component.exports